import React from 'react';
import './HeroSection.css';
/* TODO: move tagline CSS to better location*/

const HeroSection = () => {
  return (
    <section className="hero is-primary is-bold">
      <div id="tagline" className="hero-body">
        <div className="container">
          <div className="columns">
            {/* Left Column for Hero Text */}
            <div className="column is-half">
              <h1 className="title">
                What do we actually mean by <br /> "soil health" across Europe?
              </h1>
              <h2 className="subtitle">
                See how soil health is understood by stakeholders from different regions, land-uses or backgrounds.
              </h2>
            </div>
            
            {/* Right Column for Icons and Subtitles */}
            <div className="column is-half">
              <div className="columns is-vcentered is-mobile">
                {/* Icons and Text */}
                <div className="column has-text-centered">
                  <span className="icon is-large"><i className="fa-solid fa-users fa-2x"></i></span>
                  <p>500+ participants<br />in 5 user groups</p>
                </div>
                
                <div className="column has-text-centered">
                  <span className="icon is-large"><i className="fa-solid fa-layer-group fa-2x"></i></span>
                  <p>7 soil health aspects<br />or topics</p>
                </div>
                
                <div className="column has-text-centered">
                  <span className="icon is-large"><i className="fa-solid fa-flag fa-2x"></i></span>
                  <p>11 countries and<br />9 languages</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
